import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  MenuItem,
  Container,
  Grid,
  Typography,
  InputLabel,
  FormControl,
  Box,
  CircularProgress,
  TextField,
} from "@mui/material";
import Select from "@mui/material/Select";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

// ----------------------------------------------------------------------

export default function ResultMatchPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [competition, setCompetition] = useState(null);
  const [matchId, setMatchId] = useState(false);
  const [match, setMatch] = useState({
    winner_team_id: null,
    homeScore: null,
    awayScore: null
  });
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    if (searchParams.has("matchId")) {
      setLoading(true);

      let matchId = searchParams.get("matchId");
      setMatchId(Number(matchId));

      const fetchDataMatch = async () => {
        let { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/match/${matchId}`
        );
        data = data[0];

        setMatch({
          winnerTeamId: data?.winnerTeamId,
          homeScore: data?.result?.homeScore,
          awayScore: data?.result?.awayScore
        });

        setTeams([
          {
            teamId: data?.homeTeamId,
            name: data?.homeTeamName,
            type: 'home team'
          },
          {
            teamId: data?.awayTeamId,
            name: data?.awayTeamName,
            type: 'away team'
          }
        ])
        return data;
      };

      fetchDataMatch().finally(() => setLoading(false))
    }

    if (searchParams.has("type")) {
      const competition = searchParams.get("type");
      setCompetition(competition);
    }
  }, [searchParams])

  const handleChange = (event) => {
    const { name, value } = event.target;
    setMatch({ ...match, [name]: value });
  };

  const handleSubmit = () => {
    if (!!matchId || !!match) {
      setLoading(true);
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/match/result/${matchId}`, 
          match
        )
        .then(function () {
          navigate(`/dashboard/matches?type=${competition}`);
        })
        .finally(() => setLoading(false))
    }
  };

  return (
    <>
      <Helmet>
        <title> Result Match </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Set Result Match
          </Typography>
        </Stack>

        <Card style={{ padding: 20 }}>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <InputLabel id="demo-simple-select-label-home_team">Winning Team</InputLabel>
                  <Select
                    labelId="demo-simple-select-label-home_team"
                    id="demo-simple-select-home_team"
                    value={match.winnerTeamId || null}
                    name="winnerTeamId"
                    label="WWinning Team"
                    onChange={(e) => handleChange(e)}
                  >
                    {teams.map((team) => (
                      <MenuItem value={team.teamId} key={`winner_team_${team.teamId}`}>
                        {`${team.name} (${team.type})`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <TextField
                    label="Home score"
                    placeholder="Home score" 
                    type="text" 
                    name="homeScore" 
                    value={match?.homeScore || ""}  
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>

                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <TextField
                    label="Away score"
                    placeholder="Away score" 
                    type="text" 
                    name="awayScore" 
                    value={match?.awayScore || ""}  
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>

              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Button
                  variant="contained"
                  onClick={() => handleSubmit()}
                >
                  update
                </Button>
              </Grid>
            </Grid>
          )}
        </Card>
      </Container>
    </>
  );
}
